export const getConstraints = (isMac, cameraType) => {
    return isMac ?
        {
            audio: false,
            video: {
                facingMode: cameraType,
                width: 1280,
                height: 720
            }
        } : {
            audio: false,
            video: {
                facingMode: cameraType,
                width: { ideal: 1920 }, // 1920
                height: { ideal: 1080 }, // 1080
                focusMode: 'continuous'
            }
        };
};

export const getConstraintsIos = (cameraType) => {
    return {
        audio: false,
        video: {
            facingMode: cameraType,
            width: { ideal: 1920 }, // 1920
            height: { ideal: 1920 }, // 1920
            focusMode: 'continuous',
            // zoom: 1.5,
        }
    }
};
